export const REASON_OPTIONS = [
  { value: "buscar_oferta", label: "Buscar oferta" },
  { value: "agendamento_visitas", label: "Agendamento de visitas" },
  { value: "upsell", label: "Upsell" },
  { value: "negociar_renovacao", label: "Negociar valores de renovação" },
  {
    value: "confirmar_disponibilidade",
    label: "Confirmar disponibilidade / Valores / Amenidades do espaço",
  },
  { value: "troca_sala_rescisao", label: "Troca de sala / Rescisão" },
] as const;

export const DOCUMENT_OPTIONS = [
  { value: "alvara", label: "Alvará" },
  { value: "avcb", label: "AVCB" },
  { value: "habite_se", label: "Habite-se" },
  { value: "iptu", label: "IPTU" },
  { value: "matricula_imovel", label: "Matrícula Atualizada do Imóvel" },
  { value: "outro", label: "Outro" },
] as const;

export const CHANGE_REQUEST_OPTIONS = [
  { value: "atualizar_dados", label: "Atualizar dados" },
  {
    value: "confirmar_disponibilidade",
    label: "Confirmar disponibilidade",
  },
  { value: "outro", label: "Outro" },
] as const;

export const AVAILABLE_HOURS = [
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
] as const;
